import api from "./capTableApi";
import { CustomResponse } from "../types/CustomResponse";

export type OnboardStage3CompanyInput = {
  name: string;
  cin: string;
  companyCurrency?: string;
  jurisdiction: string;
  valuation?: number;
  valuationDate?: string;
  sharePrice?: number;
  emails?: string[];
  isTaskManagerCompany?: boolean;
  isPrivate?: boolean;
};

export type OnboardStage3CompanyResponse = {
  companyId: string;
  name: string;
  cin: string;
  currency: string;
  valuation?: number;
  valuationDate?: string;
  sharePrice?: number;
  isPrivate?: boolean;
  isTaskManagerCompany?: boolean;
};

export type EditCaptableInput = {
  companyId: string;
  name: string;
  cin: string;
  companyCurrency?: string;
  jurisdiction?: string;
  valuation?: number;
  valuationDate?: string;
  sharePrice?: number;
  emails?: string[];
};

export async function onboardStage3Company({
  isPrivate,
  ...data
}: OnboardStage3CompanyInput): Promise<
  CustomResponse<OnboardStage3CompanyResponse>
> {
  return api
    .post("/v1/taskManager/onboard-stage3", data)
    .then((res) => res.data);
}

export async function editCaptable(
  data: EditCaptableInput
): Promise<CustomResponse<OnboardStage3CompanyResponse>> {
  return api
    .post("/v1/taskManager/edit-captable", data)
    .then((res) => res.data);
}
